import React from "react";
import BG from "../images/BgAccelor.png";
import MD2 from "../images/CoreTeamImages/md-bgr.png";
import CEO from "../images/CoreTeamImages/ceo2-nbg.png";
import SalilDey from "../images/CoreTeamImages/sll-nbg.png";
import HeadQuality from "../images/CoreTeamImages/HeadQuality.png";
import RanjitSingh from "../images/CoreTeamImages/rnjt-nbg.png";
import AnimatedElement from "../components/AnimatedElement";
import TransitionPage from "../TransitionPage";
import RevealText from "../components/TextReveal2";
import HeadEngineering from "../images/CoreTeamImages/HeadEngineering.png";
import HeadProduction from "../images/CoreTeamImages/HeadProduction.png";
import HeadMM from "../images/CoreTeamImages/HeadMM2.png";

function AboutUs() {
  return (
    <TransitionPage>
     <div className="w-full h-screen overflow-hidden">
  <img 
    alt="Accelor" 
    className="w-full h-full object-cover object-top" 
    src={BG} 
  />
</div>
      <div className="min-h-[90vh] flex flex-col  bg-gray-100 relative">
        <div className="flex flex-col gap-6 pt-10 items-center bg-[#425472] text-[#e7eaed] px-[10%] max-sm:px-3">
         <RevealText
            text="About Accelor"
            css="text-[2.5rem] after:bg-[#fff] max-sm:text-[26px] text-white  uppercase font-bold"
          />

          <div className="flex max-sm:flex-col items-center justify-evenly gap-7">
            <div className="flex-[3] text-[16px] flex flex-col gap-3">
              <AnimatedElement direction="from-down">
                <p className="text-justify">
                  Accelor Microsystems is a defence Manufacturing company and is
                  approved supplier of DRDO founded in 2010, located in the
                  Northern Indian city of Mohali. Accelor is well equipped with
                  in-house hardware and software development capabilities, fully
                  automatic Manufacturing facilities and Environmental Test Laboratory
                  under one roof. Accelor Microsystems align itself with “Make
                  in India” initiative of GoI.
                </p>
              </AnimatedElement>
              <AnimatedElement direction="from-down" delayAn="0.1">
                <p className="text-justify ">
                  Accelor is a manufacturer of defence systems with in-house R&D
                  and state of the art Manufacturing facility. Accelor is having
                  inhouse Quality Team with IPC certified specialists to ensure quality
                  standards as per applicable IPC/MIL/JSS 55555 standards. R&D
                  team has expertise in Hardware designing and simulation,
                  Software Development, Mechanical Designing and simulation, AI
                  and Machine Learning applications development etc. Accelor
                  holds capability from prototype to mass production.
                </p>
              </AnimatedElement>
              <AnimatedElement direction="from-down" delayAn="0.1">
                <p className="text-justify ">
                  Accelor Microsystems is located in the Industrial Focal Point, Mohali,  with a total built-up area of 6240.5 Sq. Ft. Being in the city of Mohali, Accelor holds the advantage of being in vicinity of TBRL- DRDO, Chandigarh. Our Team has already delivered many of the defence products to major stakeholders with Quality clearances from DGQA, R&QA.
                </p>
              </AnimatedElement>
            </div>
          </div>
        </div>
        {/* </AnimatedElement> */}
        <svg
          className=" bottom-0"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 100"
          fill="#425472"
        >
          <path
            d="M0 0v99.7C62 69 122.4 48.7 205 66c83.8 17.6 160.5 20.4 240-12 54-22 110-26 173-10a392.2 392.2 0 0 0 222-5c55-17 110.3-36.9 160-27.2V0H0Z"
            opacity=".5"
          ></path>
          <path d="M0 0v74.7C62 44 122.4 28.7 205 46c83.8 17.6 160.5 25.4 240-7 54-22 110-21 173-5 76.5 19.4 146.5 23.3 222 0 55-17 110.3-31.9 160-22.2V0H0Z"></path>
        </svg>
        <div className="flex flex-wrap items-center py-10 relative justify-center gap-3">
          <RevealText
            text="OUR CORE TEAM"
            css="text-[2.5rem] after:bg-[#425472] max-sm:text-[26px] text-[#425472] uppercase font-bold"
          />

          {/* Row 1 - 4 Members */}
          <div className="flex flex-wrap gap-3 mt-4 justify-center w-full">
            <TeamMember
              img={MD2}
              name="Sh. Mukhwinder Singh"
              designation="Managing Director & Head R&D"
              qualification="(MTech. - ECE) - >25 yrs of Exp."
            />
            <TeamMember
              width={240}
              img={CEO}
              name="Dr. Manvjeet Kaur"
              designation="Director & CEO"
              qualification="(PhD in CSE) - >20 yrs of Exp."
            />
            <TeamMember
              img={SalilDey}
              name="Dr. Salil Dey"
              designation="Director Operations"
              qualification="(PhD in Quality Management) - >30 yrs of Exp."
            />
            <TeamMember
              img={RanjitSingh}
              name="Dr. Ranjit Singh"
              designation="Head AMETL"
              qualification="(Phd in Mech. Engineering) - >20 yrs of Exp."
            />
          </div>

          {/* Row 2 - 4 Members */}
          <div className="flex flex-wrap gap-3 justify-center w-full">
            <TeamMember
              img={HeadQuality}
              name="Mr. Mahendra Pratap Maurya"
              designation="Head Quality"
              qualification=" ECE (Diploma) - >20 yrs of Exp."
            />
            
            <TeamMember
              img={HeadEngineering}
              name="Mr. Surinder Pal Sharma"
              designation="Head Engineering"
              qualification="BTech. (ECE) - >20 yrs of Exp."
            />
            <TeamMember
              img={HeadProduction}
              name="Mr. Upinderjit Singh Cheema"
              designation="Head Production"
              qualification="B.E. in Electrical Engineering - >25 yrs of Exp."
            />
            <TeamMember
              img={HeadMM}
              name="Mr. Sandeep Kumar"
              designation="Head Material Management"
              qualification="Graduate Diploma in Material Management (IIMM) - >15 yrs of Exp."
            />
          </div>
        </div>
      </div>
    </TransitionPage>
  );
}

function TeamMember({
  name,
  img,
  designation,
  qualification,
  css = "",
  width = 150,
}) {
  return (
    <div className=" flex flex-col items-center justify-end bg-slate-200 group  w-[300px] pb-5">
      <img
        src={img}
        width={width}
        className="grayscale  group-hover:grayscale-0  transition duration-200 "
      />
      <div className="">
        <h1 className=" archivo font-semibold mt-2">{name}</h1>
        <p className="archivo text-[14px]"> {designation}</p>
        <p className="archivo text-[14px]">{qualification}</p>
      </div>
    </div>
  );
}

export default AboutUs;
